import React from 'react';
import PropTypes from 'prop-types';

function IconPlay({ size = 40, color = `#01FF95`, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width={size} height={size} rx={size / 2} fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M15.1165 11.1318L27.4158 19.6141C27.686 19.8004 27.686 20.1996 27.4158 20.3859L15.1165 28.8681C14.8055 29.0827 14.3815 28.86 14.3815 28.4822V11.5177C14.3815 11.1399 14.8055 10.9173 15.1165 11.1318Z" fill="#0F0F10"/>
    </svg>
  )
}

IconPlay.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string,
  className: PropTypes.string
}

export default IconPlay;
